import React from 'react'
import classNames from 'classnames'
import { randomString, translate } from '../../../../../utils'
import { bindSvgDragActionToImageElement } from '../../../../../utils/svg'
import { bindDoubleClickToElement } from '../../../../../utils/svg/double_click'

function JujoSVGNewImageBtn({ svg_id, setFocusedElement }) {
  const handleAddNewImageClicked = () => {
    const svg_element = document.getElementById(svg_id)

    const bbox = svg_element.getBBox()
    const { height } = bbox

    const g_element = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'g'
    )

    const gid = randomString(16)
    g_element.setAttribute('id', gid)

    const image_element = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'image'
    )

    image_element.setAttribute(
      'href',
      'data:image/svg+xml;base64,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'
    )

    image_element.setAttribute('parsed', true)

    image_element.setAttribute('width', 80)
    image_element.setAttribute('height', 80)

    image_element.setAttribute('transform', `matrix(1,0,0,1,50,${height / 2})`)

    g_element.appendChild(image_element)
    svg_element.appendChild(g_element)

    setTimeout(() => {
      bindSvgDragActionToImageElement(svg_id, image_element)
      bindDoubleClickToElement(svg_id, image_element, setFocusedElement)

      const doubleClickEvent = new Event('dblclick', {})
      image_element.dispatchEvent(doubleClickEvent)
    }, '1')
  }

  return (
    <div>
      <div
        className={classNames(
          'd-flex flex-column align-items-center w-80px w-md-70px p-1 p-md-0 m-1 m-md-0'
        )}
        role="button"
        tabIndex={0}
        onClick={() => handleAddNewImageClicked()}
        onKeyPress={() => handleAddNewImageClicked()}
      >
        <div className={classNames('fs-8')}>{translate('new_image')}</div>
        <div
          className={classNames('background-image add-image-icon')}
          style={{ width: 25, height: 25 }}
        />
      </div>
    </div>
  )
}

export default JujoSVGNewImageBtn
